export const reflow = (node: Element) => node.scrollTop;
